module.exports = __webpack_public_path__ + "static/media/IlotF_synthese_2.38a84711.webp";